<template>
  <a
    href="https://origem.digital"
    target="_blank"
    title="Origem Digital - gestão de tarefas e projetos"
  >
    <Logo height="14" alt="Origem Digital - gestão de tarefas e projetos" />
  </a>
</template>

<script>
export default {
  name: 'ExternalLinkBaserowLogo',
}
</script>
